var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1Digitalization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 38h-9a4 4 0 00-4 4v18a4 4 0 004 4h9a4 4 0 004-4V42a4 4 0 00-4-4zm0 22h-9V42h9v18zM13 47h34v4h-7v9h7v4H26v-4h10v-9H12.81A3.87 3.87 0 019 47.18V18.81A3.87 3.87 0 0112.82 15h50.37A3.87 3.87 0 0167 18.82V34h-4V19H13v28z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Digitalization.d4ddf324.svg";
export { SvgH1Digitalization as ReactComponent };